import moment from "moment";
import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { useQuery } from "react-query";
import api from "src/rest/api";

// import { Container } from './styles';
interface ProtocolInfo {
  id: string;
  active: boolean;
  title: string;
  enable: string;
  disable: string;
  photoURL: string;
  name: string;
}

interface Props {
  list: string[];
}

const ProtocolsInfoList: React.FC<Props> = ({ list }) => {
  const [prots, setProts] = useState<ProtocolInfo[]>();

  useEffect(() => {
    setProts([]);
    refetch();
  }, [list]);

  const { isLoading, refetch } = useQuery(
    ["listing", list.length],
    () =>
      api
        .post<
          ProtocolInfo[]
        >("/events/protocols/list", { list: list.slice(0, 20) })
        .then((res) => {
          setProts(res.data);
          return res.data;
        }),
    { enabled: false },
  );

  if (isLoading || !prots?.length)
    return (
      <div className="m-auto">
        <ThreeDots color="#000" height={100} />
      </div>
    );

  return (
    <>
      {prots &&
        prots.map((e) => (
          <div
            key={e.id}
            className="mb-4 flex flex-row justify-between rounded border-b p-2"
          >
            <div className="items-center">
              <div className="border-primary-500 mx-2 rounded-full border bg-red-300 px-1">
                <p className="text-primary-500 text-xs uppercase">
                  {e.active ? "Ativo" : "Inativo"}
                </p>
              </div>
              <img
                className="mr-2 h-10 w-10 rounded-full"
                src={e.photoURL ?? require("src/assets/png/alt.png")}
                alt={"Profile Image"}
              />
              <p>{e.name}</p>
            </div>
            <div className="flex flex-row items-center justify-end pl-3">
              <div className="flex flex-col">
                <p className="text-end text-sm">
                  Ativação:{" "}
                  {e.enable ? moment(e.enable).format("LL") : "DESABILITADA"}
                </p>

                <p className="text-end text-sm">
                  Desativação:{" "}
                  {e.disable ? moment(e.disable).format("LL") : "DESABILITADA"}
                </p>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default ProtocolsInfoList;
